var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileUpload',{attrs:{"files":_vm.inputValue,"accept":"image/png, image/jpeg"},on:{"change":_vm.onChangeFileUpload}})}
var staticRenderFns = []

export { render, staticRenderFns }